import { Provider } from "@angular/core";
import { OccProductSearchPageNormalizer, ProductSearchAdapter } from "@spartacus/core";
import { CustomOccProductSearchAdapter } from "../SGRE-custom/product-list-page/services/custom-occ-product-search.adapter";
import { SavedCartAdapter } from "@spartacus/cart/saved-cart/core";
import { CustomSavedCartAdapter } from "../SGRE-custom/save-cart/adaptor/custom-save-cart.adaptor";
import { CheckoutDeliveryModesAdapter } from "@spartacus/checkout/base/core";
import { CustomOccCheckoutDeliveryModesAdapter } from "../SGRE-custom/checkout/services/custom-occ-checkout-delivery-modes.adapter";
import { CustomProductSearchPageNormalizer } from "../SGRE-custom/product-list-page/store/converters/custom-occ-product-search-page-normalizer";

export const CustomProvidersConfig: Provider[] = [
    {
        provide: ProductSearchAdapter,
        useClass: CustomOccProductSearchAdapter
    },
    {
        provide: SavedCartAdapter,
        useClass: CustomSavedCartAdapter,
    },
    {
        provide: CheckoutDeliveryModesAdapter,
        useClass: CustomOccCheckoutDeliveryModesAdapter
    },
    {
        provide: OccProductSearchPageNormalizer,
        useClass: CustomProductSearchPageNormalizer,
    },
]